import React, { Fragment, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { BiHelpCircle } from 'react-icons/bi';
import WorkspaceModal from './WorkspaceModal';
import { PAGE_HELP } from './pageHelpContent';
import { loadOrganisationSettings } from '../../utils/organisationSettings';
import './PageHelp.scss';

const PageHelp = ({ topic }) => {
  const article = PAGE_HELP[topic];
  const [open, setOpen] = useState(false);
  const [helpText, setHelpText] = useState('');
  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    loadOrganisationSettings().then((pack) => {
      if (!cancelled) setHelpText(pack?.settings?.workspace?.helpText || '');
    });
    return () => {
      cancelled = true;
    };
  }, [open]);
  if (!article) return null;

  return (
    <>
      <button type="button" className="page-help__btn" onClick={() => setOpen(true)}>
        <BiHelpCircle aria-hidden />
        Help
      </button>
      <WorkspaceModal
        show={open}
        onHide={() => setOpen(false)}
        title={article.title}
        description={article.summary}
        size="lg"
        enableTestFillHotkey={false}
        footer={(
          <Button size="sm" variant="primary" onClick={() => setOpen(false)}>
            Close
          </Button>
        )}
      >
        <div className="page-help">
          {helpText ? <p className="page-help__note">{helpText}</p> : null}
          {article.who?.length ? (
            <section>
              <h3>Who does this work</h3>
              <ul>
                {article.who.map((line) => <li key={line}>{line}</li>)}
              </ul>
            </section>
          ) : null}
          {article.use?.length ? (
            <section>
              <h3>How to work on this module</h3>
              <ol>
                {article.use.map((line) => <li key={line}>{line}</li>)}
              </ol>
            </section>
          ) : null}
          {article.edit?.length ? (
            <section>
              <h3>Editing a record</h3>
              <ul>
                {article.edit.map((line) => <li key={line}>{line}</li>)}
              </ul>
            </section>
          ) : null}
          {article.fields?.length ? (
            <section>
              <h3>What the fields mean</h3>
              <dl>
                {article.fields.map(([label, text]) => (
                  <div key={label}>
                    <dt>{label}</dt>
                    <dd>{text}</dd>
                  </div>
                ))}
              </dl>
            </section>
          ) : null}
          {article.links?.length ? (
            <section>
              <h3>How this module connects</h3>
              <ul>
                {article.links.map((line) => <li key={line}>{line}</li>)}
              </ul>
            </section>
          ) : null}
          {article.ai ? (
            <section>
              <h3>How AI helps here</h3>
              <p>{article.ai.helps}</p>
              {article.ai.flow?.length ? (
                <div className="page-help__flow" aria-label="How to use AI on this screen">
                  {article.ai.flow.map((step, index) => (
                    <Fragment key={step}>
                      {index ? <span className="page-help__arrow" aria-hidden>→</span> : null}
                      <span className="page-help__step">{step}</span>
                    </Fragment>
                  ))}
                </div>
              ) : null}
              {article.ai.use?.length ? (
                <ol>
                  {article.ai.use.map((line) => <li key={line}>{line}</li>)}
                </ol>
              ) : null}
              {article.ai.note ? <p className="page-help__note">{article.ai.note}</p> : null}
            </section>
          ) : null}
        </div>
      </WorkspaceModal>
    </>
  );
};

export default PageHelp;
